import {useCallback} from 'react'

import {useSuiContext} from '@s-ui/react-context'
import {getProvincesNameById} from '@adv-mt/mt-form-province'

const useLabel = ({search}) => {
  const {domain} = useSuiContext()

  const config = domain.get('config')

  const {FILTER_NAMES} = config.get('searchFilters')
  const provincesByCCAA = config.get('provincesByCCAA')

  const getLabel = useCallback(() => {
    const provincesValue = search[FILTER_NAMES.PROVINCE]
    const {radio: locationRadioValue, text: locationTextValue} = search[FILTER_NAMES.LOCATION]

    if (locationTextValue && locationRadioValue) return `${locationRadioValue} kms de ${locationTextValue}`
    if (locationTextValue) return locationTextValue
    if (provincesValue.length)
      return getProvincesNameById({availableProvinces: provincesByCCAA, selectedProvinces: provincesValue.map(String)})
    return 'Todas'
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  return {label: getLabel()}
}

export default useLabel
